var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCongratsMemberSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-check",
    clipPath: "url(#clip0_6179_30441)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M13.3359 18V16.3333C13.3359 15.4493 12.9847 14.6014 12.3596 13.9763C11.7345 13.3512 10.8867 13 10.0026 13H4.16927C3.28522 13 2.43737 13.3512 1.81225 13.9763C1.18713 14.6014 0.835938 15.4493 0.835938 16.3333V18M14.1693 9.66667L15.8359 11.3333L19.1693 8M10.4193 6.33333C10.4193 8.17428 8.92689 9.66667 7.08594 9.66667C5.24499 9.66667 3.7526 8.17428 3.7526 6.33333C3.7526 4.49238 5.24499 3 7.08594 3C8.92689 3 10.4193 4.49238 10.4193 6.33333Z",
    stroke: "#BB3240",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6179_30441"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCongratsMemberSvg);
export default __webpack_public_path__ + "static/media/CongratsMemberSvg.826189a07de47fdcb3a9901b24a1969e.svg";
export { ForwardRef as ReactComponent };